export default __webpack_public_path__ + "static/media/fireFN33.7bce7e9c.svg";